import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorSummaryComponent } from '../error-summary/error-summary.component';
import { ViewModelService } from '../shared/view-model.service';

@Component({
   selector: 'app-stepone-confirm',
   standalone: true,
   imports: [ErrorSummaryComponent],
   templateUrl: './stepone-confirm.component.html',
   styleUrl: './stepone-confirm.component.scss',
})
export class SteponeConfirmComponent {
   public vm = inject(ViewModelService);
   private router = inject(Router);

   changeDetails(): void {
      if ((window as any).ga) {
         (window as any).ga('send', 'event', {
            eventCategory: 'ID&V',
            eventLabel: 'Step One - Confirmation',
            eventAction: 'Re-enter details',
         });
      }
      this.router.navigate(['stepone']);
   }

   confirmAddress(): void {
      if (this.vm.tenancy.allowPortalRegistration) {
         this.router.navigate(['steptwo']);
      } else {
         this.router.navigate(['abort/PortalRegistrationNotAllowed']);
      }
   }

   notMyAddress(): void {
      this.router.navigate(['abort/NotMyAddress']);
   }
}
